import BaseExtension from './base';

import createElement from '../utils/createElement';

const CN = 'rmp-ext-title';
const TITLE_CN = `${CN}__title`;

export default class TitleExtension extends BaseExtension {
   /** @type {HTMLElement} */
   $outer;
   constructor(player, state, options) {
      super(player, state, options);
      this.logger.debug('title:extension:creating');

      this.render();

      this.logger.debug('title:extension:created');
   }

   render() {
      this.$outer = createElement('div', { class: CN, 'data-testid': 'title' });
      const span = createElement('span', { class: TITLE_CN, title: this.options.title, tabindex: 0 }, this.$outer);
      span.textContent = this.options.title || '';
   }

   getOuter() {
      return this.$outer;
   }

   destroy() {
      super.destroy();
      if (this.$outer) {
         const parent = this.$outer.parentNode;
         parent.removeChild(this.$outer);
         this.$outer = null;
      }
   }
}
